<h2 mat-dialog-title>Confirmaci&oacute;n</h2>
<mat-dialog-content>
  <p>¿Est&aacute; seguro que desea reasignar los documentos del usuario seleccionado?</p>
  <div class="stats-container">
    <div class="stat-item">
      <span class="label">Origen:</span>
      <span class="value">{{ data.data.origen.nombres }} <br>({{ data.data.origen.departamento }})</span>
    </div>
    <div class="stat-item">
      <span class="label">Destino:</span>
      <span class="value">{{ data.data.destinatario.nombres }} <br>({{ data.data.destinatario.departamento }})</span>
    </div>
    <div class="stat-item">
      <span class="label">Elaborados:</span>
      <span class="value">{{ data.contador.elaboracion }}</span>
    </div>
    <div class="stat-item">
      <span class="label">Recibidos:</span>
      <span class="value">{{ data.contador.recibido}}</span>
    </div>
    <div class="stat-item">
      <span class="label">Tareas:</span>
      <span class="value">{{ data.contador.tarea }}</span>
    </div>
  </div>
</mat-dialog-content>
@if(saving) {
<mat-progress-bar  mode="indeterminate"></mat-progress-bar>
}
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="saving">Cancelar</button>
  <button mat-flat-button color="primary" (click)="onConfirm()" [disabled]="saving">Confirmar</button>
</mat-dialog-actions>
